<fbr-chip *ngFor="let label of config.labels" [className]="label.className || ''" [tooltip]="label.tooltipKey | translate">{{ label.labelKey | translate }}</fbr-chip>
